export default __webpack_public_path__ + "static/media/photo--lg--james-1.1823dbc8.jpg";